module.exports = __webpack_public_path__ + "img/share-task-account.19974653.svg";